module.exports = __webpack_public_path__ + "public/images/science.36647cc38ba0d7316556a00a02a48113.png";